import { EntitySwitch, isComponentType } from '@backstage/plugin-catalog';
import { serviceEntityPage } from './serviceEntityPage';
import { websiteEntityPage } from './websiteEntityPage';
import { defaultEntityPage } from './defaultEntityPage';
import { libraryEntityPage } from './libraryEntityPage';
import { overviewContent } from './overviewContent';

export type ComponentPageProps = {
  serviceEntityPage?: React.JSX.Element;
  websiteEntityPage?: React.JSX.Element;
  libraryEntityPage?: React.JSX.Element;
  defaultEntityPage?: React.JSX.Element;
};
export const componentPage = (props?: ComponentPageProps) => (
  <EntitySwitch>
    <EntitySwitch.Case if={isComponentType('service')}>
      {props?.serviceEntityPage ?? serviceEntityPage()}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('website')}>
      {props?.websiteEntityPage ?? websiteEntityPage({})}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('library')}>
      {props?.websiteEntityPage ?? libraryEntityPage({})}
    </EntitySwitch.Case>

    <EntitySwitch.Case>
      {props?.defaultEntityPage ?? defaultEntityPage(
        {
          overview: overviewContent({})
        }
      )}
    </EntitySwitch.Case>
  </EntitySwitch>
);
